"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Order Checkout Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageToJSON = exports.PageFromJSONTyped = exports.PageFromJSON = exports.Page = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var Page;
(function (Page) {
    Page["Basket"] = "basket";
    Page["LoginPage"] = "loginPage";
    Page["DeliveryPage"] = "deliveryPage";
    Page["ChangeDeliveryPage"] = "changeDeliveryPage";
    Page["PaymentPage"] = "paymentPage";
    Page["ChangePaymentPage"] = "changePaymentPage";
    Page["DelayedPaymentAd"] = "delayedPaymentAd";
    Page["CreditPaymentAd"] = "creditPaymentAd";
    Page["PremiumAd"] = "premiumAd";
    Page["InsuranceAd"] = "insuranceAd";
    Page["UpgradeInsuranceAd"] = "upgradeInsuranceAd";
    Page["CheckAndOrder"] = "checkAndOrder";
    Page["OrderConfirmation"] = "orderConfirmation";
    Page["NoOrder"] = "noOrder";
})(Page = exports.Page || (exports.Page = {}));
function PageFromJSON(json) {
    return PageFromJSONTyped(json, false);
}
exports.PageFromJSON = PageFromJSON;
function PageFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PageFromJSONTyped = PageFromJSONTyped;
function PageToJSON(value) {
    return value;
}
exports.PageToJSON = PageToJSON;
//# sourceMappingURL=Page.js.map